import React, { useContext } from 'react';
import * as Env from 'widget/env';

interface WidgetContext {
  isWidgetActive: boolean;
  platform: string | null;
  setIsWidgetActive: Env.SetState<boolean>;
  tariff: Env.Tariff;
  widget: Env.Widget;
}

const WidgetContext = React.createContext<WidgetContext>({} as WidgetContext);

export const useWidgetContext = () => useContext(WidgetContext);
export default WidgetContext;
